import {DataContentWrapper} from '@hconnect/common/containers'

import {TasksStatusesSummary} from '../components'
import {useTasksStatusesCounts} from '../hooks'
import {UseTasksStatusesCountsParams} from '../types'

type Props = {
  params: UseTasksStatusesCountsParams
}

export const TasksStatusesSummaryContainer = ({params}: Props) => {
  const {data, isLoading, isError, refetch} = useTasksStatusesCounts(params)

  return (
    <DataContentWrapper
      showLoader={false} // component handles loading state
      isNoData={false} // component handles no data state
      isError={isError}
      retryFunction={refetch}
      placeholderWrapperSx={{height: 100}}
    >
      <TasksStatusesSummary data={data} showLoader={isLoading} />
    </DataContentWrapper>
  )
}
